import { StyleSheet, Platform } from 'react-native';

import { Fonts, Colors } from '../Themes';

export default StyleSheet.create({
  containerStyle: {
    marginTop: 16.7,
    // marginHorizontal: 16,
    padding: 16,
    borderRadius: 6.2,
  },
  primaryBackground: theme => ({
    elevation: 6,
    backgroundColor: theme.colors.cardBackgroundColor,
    shadowColor: Platform.OS === 'ios' && Colors.linegrey,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
  }),
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    marginBottom: 8.3,
  },
  iconAndTitleContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    flexShrink: 1,
  },
  leftIconStyle: {
    marginRight: 8,
  },
  description: {
    fontSize: Platform.OS === 'ios' ? 14.6 : 14,
    lineHeight: 18.7,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 16.6,
  },
  buttonStyle: {
    ...Fonts.type.bold,
    height: 32,
    paddingHorizontal: 17,
    flex: 1,
  },
  textButtonStyle: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  },
  primaryButtonStyle: {
    marginRight: 16.6,
  },
  loadingContainerStyle: theme => ({
    marginTop: 16,
    backgroundColor: theme.colors.cardBackgroundColorThree,
    padding: 16,
    borderRadius: 6,
    height: 166,
  }),
});
